<template>
  <div>
    <search-supplier-cpe @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          v-if="isAdmin"
          type="primary"
          @click="showDeleteToInventoryModal"
        >删CPE退库</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <delete-cpes-to-inventory
      v-if="isShowDeleteToInventoryModal"
      :visible.sync="isShowDeleteToInventoryModal"
      :sns="selectedSns"
      :cpe-supplier-id="cpeSupplierId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { findCpeSupplierCpes } from '@/api/cpe_supplier'
import Pagination from '@/components/Pagination'
import SearchSupplierCpe from '@/views/cpes/supplier/Search'

export default {
  name: 'SupplierCpeList',
  components: {
    Pagination,
    SearchSupplierCpe,
    DeleteCpesToInventory: () => import('@/views/batch_operations/DeleteCpesToInventory')
  },
  data() {
    return {
      data: [],
      loading: true,
      isShowDeleteToInventoryModal: false,
      selectedRowKeys: [],
      pagination: {
        total_count: 0
      },
      query: {},
      columns: [
        {
          title: '采购型号',
          dataIndex: 'cpe_model_name',
          width: 140
        },
        {
          title: '对外展示型号',
          dataIndex: 'display_model',
          width: 140
        },
        {
          title: '通讯方式',
          dataIndex: 'comm_mode_name',
          width: 140
        },
        {
          title: 'SN',
          dataIndex: 'sn',
          width: 160
        },
        {
          title: 'IMEI1',
          dataIndex: 'imei1',
          width: 160
        },
        {
          title: 'IMEI2',
          dataIndex: 'imei2',
          width: 160
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '所属客户',
          dataIndex: 'agent_name',
          width: 160
        }
      ]
    }
  },
  computed: {
    cpeSupplierId() {
      return parseInt(this.$route.params.id)
    },
    isAdmin() {
      return this.$store.getters.userRole === 'super_admin' || this.$store.getters.userRole === 'admin'
    },
    selectedSns() {
      return this.data
        .filter((item) => this.selectedRowKeys.includes(item.id))
        .map((item) => item.sn)
        .filter((sn) => sn)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showDeleteToInventoryModal() {
      this.isShowDeleteToInventoryModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findCpeSupplierCpes(this.cpeSupplierId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
